module.exports = __webpack_public_path__ + "img/chinesecompany89.59e98dca.png";